<div class="ecom-page-container ecom-auctions-list-container">
  <af-detail (bidPlaced)="_onBidPlaced($event)"
             [auction]="_auction"></af-detail>
</div>